import utilHelpers from 'monstera/src/modules/common/helpers/utilHelper';

export default {
  ...utilHelpers,
  getSelectOptionsContacts,
};

function getSelectOptionsContacts(
  contacts: ContactDTO[] | undefined
): SelectOption[] {
  if (!contacts) return [] as SelectOption[];

  return contacts.map((item) => {
    const missingInfo = { birthday: !item.birthday, gender: !item.gender };
    return {
      value: item.id,
      label: `${item.name} ${item.surname}`,
      missingInfo,
      backgroundColor:
        missingInfo.birthday || missingInfo.gender ? `#fbe6d0 !important` : '',
    };
  }) as SelectOption[];
}
